// src/client/main.tsx
import React from "react"
import ReactDOM from "react-dom/client"
import App from "./App.tsx"
import { startRoleWatcher } from "./lib/roleLive";
import "./index.css"

// // prod mode
// ReactDOM.createRoot(document.getElementById("root")!).render(
//   <React.StrictMode>
//     <App />
//   </React.StrictMode>
// )

// dev mode

// TEMP LOG — выведет всю телеграмную среду и откуда взят tg_id
const TWA = (globalThis as any)?.Telegram?.WebApp;
console.log('[TWA] initData len:', TWA?.initData?.length || 0);
console.log('[TWA] initDataUnsafe.user:', TWA?.initDataUnsafe?.user);
startRoleWatcher();

// мьютим шумные сообщения SDK по шаблону
(function muteTelegramSDKLogs() {
  const mute = /(web_app_trigger_haptic_feedback|postEvent)/i;
  ['log','debug','info'].forEach((k) => {
    const orig = (console as any)[k];
    (console as any)[k] = function (...args: any[]) {
      try {
        if (args.some(a => typeof a === 'string' && mute.test(a))) return;
      } catch {}
      return orig.apply(console, args);
    };
  });
})();

ReactDOM.createRoot(document.getElementById("root")!).render(<App />)